import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = {
  class: "container--small",
  "aria-labelledby": "intro-heading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", { id: "intro-heading" }, "Aspect Ratio Calculator")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_FormBox = _resolveComponent("FormBox")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      lightModeActive: _ctx.lightModeActive,
      onToggleLightMode: _ctx.toggleLightmode
    }, null, 8, ["lightModeActive", "onToggleLightMode"]),
    _createElementVNode("main", null, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_FormBox)
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}